function MoonIcon() {
  return (
    <span className="anticon anticon-moon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          stroke="Currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M1.693 10.35c.3 4.292 3.941 7.784 8.3 7.976 3.075.133 5.825-1.3 7.475-3.559.683-.925.316-1.541-.825-1.333-.559.1-1.134.142-1.734.117-4.075-.167-7.408-3.576-7.425-7.6a7.413 7.413 0 01.625-3.042c.45-1.034-.091-1.525-1.133-1.084-3.3 1.392-5.558 4.717-5.283 8.526z"
        />
      </svg>
    </span>
  );
}

export default MoonIcon;
